import React from "react";
import Modal from "../../../../Components/Shared/Modal";
import { symptomCheckerUrl } from "../../../../Constants/config";
import useTranslation from "../../../../Hooks/UseTranslation/use-translation";
import { _getItemFromLocal } from "../../../../Utils/Helpers/LocalKeys";
import "./ConsentComponentRestrictAccess.scss"
import { _capitalizeForLocalization } from "../../../../FitnessTracker/Utils/utils";

interface IConsentProps {
    modalIsOpen: boolean;
    handleSetConsent: ()=> void;
}

const ConsentComponentRestrictAccess = ({modalIsOpen, handleSetConsent}: IConsentProps) => {
    const {t} = useTranslation();

    const getContainerClass = () => {
        return "modal-component consent-modal-block-other-restrict-access"
    }

    const getContainerBodyClass = () => {
        return "modal-component-body consent-modal-body-restrict-access"
    }

    let managedHealthURL = `${symptomCheckerUrl}`
    if(symptomCheckerUrl.includes("covid.dev.health.jiolabs.com") || symptomCheckerUrl.includes("covid.sit.health.jiolabs.com")) {
        managedHealthURL += "/doctor-managed-dashboard/";
    } else {
        managedHealthURL += "/managed-dashboard/";
    }

    return (
        <Modal
        isOpen={modalIsOpen}
        onExitClicked={()=>{}}      
        centerAlignedModal={true}
        modalContainerClassName={getContainerClass()}
        modalBodyContainerClassName="modal-component-body consent-modal-body-restrict-access"
        modalContainerOverlay="modal-component-overlay consent-modal-overlay-restrict-access"
        >

            <div style={{height:"100%", display:"flex", flexDirection:"column", justifyContent:"center"}}>
                <div className="consent-modal-header-restrict-access">{t(_capitalizeForLocalization("You don't have access to this module"))}</div>
                <span className="consent-modal-header-restrict-access sub-text" style={{fontSize:"16px", fontFamily:"JioType-Light"}}>
                    {`Please logout from`}
                    &nbsp;
                    <a href={managedHealthURL} >
                        {`Managed health`}
                    </a>
                </span>
            </div>
          
        </Modal>
    )
}

export default ConsentComponentRestrictAccess;